import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  footerUrls: {
    privacyPolicyUrl: string;
    legalNoticeUrl: string;
    termsAndConditionsUrl: string;
  } = {
    privacyPolicyUrl: '',
    legalNoticeUrl: '',
    termsAndConditionsUrl: '',
  };
  protected readonly storage = window.localStorage;
  protected readonly environment = environment;

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('en-GB');
  }

  ngOnInit() {
    const browserLang: string | undefined = this.translate.getBrowserLang();
    if (typeof browserLang === 'string') {
      this.setUrls(browserLang);
    }
  }

  setUrls(lang: string) {
    if (lang === 'de') {
      this.footerUrls.privacyPolicyUrl = environment.privacyPolicyDeUrl;
      this.footerUrls.legalNoticeUrl = environment.legalNoticeDeUrl;
      this.footerUrls.termsAndConditionsUrl =
        environment.termsAndConditionsDeUrl;
    } else {
      this.footerUrls.privacyPolicyUrl = environment.privacyPolicyEnUrl;
      this.footerUrls.legalNoticeUrl = environment.legalNoticeEnUrl;
      this.footerUrls.termsAndConditionsUrl =
        environment.termsAndConditionsEnUrl;
    }
  }

  onTranslationKeysChange(event: boolean) {
    if (typeof event === 'boolean') {
      this.storage.setItem('translationKeys', event.toString());
      // wait for animation finish
      setTimeout(() => {
        location.reload();
      }, 500);
    }
  }
}
